"use client"

import * as React from 'react';
import PackeryGrid, {BlockTypeFilter} from "../components/grids/PackeryGrid";
import {gridRowHeights, gridTypesEnum} from "../utils/SchoolBlocksUtilities";
import {useStores} from "../stores/useStores";

const blockTypeFilters: BlockTypeFilter[] = [
    {
        id: "district",
        title: "District",
    },
    {
        id: "school",
        title: "School",
    },
    {
        id: "classroom",
        title: "Classrooms",
    },
    {
        id: "group",
        title: "Groups",
    },
]

const FeedGridPage: React.FC<{
}> = props => {
    const {gridStore, organizationStore} = useStores();

    return (
        <div id="sb-main-content">
            <div className="sb-content-width" style={{textAlign: "center"}}>
                {/*@ts-ignore*/}
                <PackeryGrid
                    gridType={gridTypesEnum.LIST_GRID}
                    htmlId={'following-grid'}
                    displayFilterByBlockType={true}
                    rowHeight={gridRowHeights.search}
                    key={organizationStore.currentOrganization.id}
                    blockTypeFilters={blockTypeFilters}
                />
                {gridStore.blocks.size === 0 && <h3>
                    There have not been any updates to organizations you are following in the last 7 days.
                </h3>}
            </div>
        </div>
    )

}

export default FeedGridPage;
